// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b39e633a","76":"c0b012f3","148":"332988c4","249":"f323c81e","345":"e70f3171","488":"9dd3b061","593":"58f25844","728":"42c29e53","789":"216db48b","844":"85de52a9"}[chunkId] + ".chunk.js";
};